import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visible: false,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChatVisible: (state, action) => {
      state.visible = action.payload;
    },
  },
});

export const { setChatVisible } = chatSlice.actions;

export default chatSlice.reducer;
